import api from "service/axios.service";
import {
  LEGALIDADE_FAIL,
  LEGALIDADE_REQUEST,
  LEGALIDADE_SUCCESS,
} from "../constants/legalidadeConstants";

export const legalidadeData = (choice) => async (dispatch) => {
  const { type, territorialCut, territory } = choice || {};
  const { value: valueCut } = territorialCut || {};
  const { label, value } = territory || {};

  dispatch({ type: LEGALIDADE_REQUEST });
  try {
    const newValueCut =
      valueCut === "rural_properties" || valueCut === "traditional_territories"
        ? "municipality"
        : valueCut;

    const res = await api.post(`/v2/legalityTerritory/${newValueCut}/`, {
      codTerritory: type,
      nameTerritory: [label],
      geocodes: [value],
    });

    const { data } = res || {};
    const [values] = data || [];

    dispatch({
      type: LEGALIDADE_SUCCESS,
      payload: values || {},
    });
  } catch (error) {
    dispatch({
      type: LEGALIDADE_FAIL,
      payload: error.response?.data.message
        ? error.message.data.message
        : error.message,
    });
  }
};
